import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
import { WbCloudyOutlined, WbSunnyOutlined } from '@mui/icons-material';
import { ResponsiveIcon } from 'console/shared/components/icon/responsive';
import ExtThermostat from './icons/ext-term.svg';
import Water from './icons/water.svg';
import AirPid from './icons/air-pid.svg';
import Air from './icons/air.svg';
const IconElement = memo(forwardRef((props, ref) => {
    const { control_mode, ...rest } = props;
    switch (control_mode) {
        case 'summer':
            return (_jsx(ResponsiveIcon, { Icon: WbSunnyOutlined, ref: ref, color: "warning", ...rest }));
        case 'external-thermostat':
            return _jsx(ResponsiveIcon, { Icon: ExtThermostat, ...rest, ref: ref });
        case 'external-thermostat-heat-request':
            return (_jsx(ResponsiveIcon, { Icon: ExtThermostat, ref: ref, ...rest, color: "warning" }));
        case 'pza':
            return (_jsx(ResponsiveIcon, { Icon: WbCloudyOutlined, ...rest, ref: ref }));
        case 'water':
            return _jsx(ResponsiveIcon, { Icon: Water, ref: ref, ...rest });
        case 'air':
            return (_jsx(ResponsiveIcon, { color: "action", Icon: Air, ...rest, ref: ref }));
        case 'air-pza':
            return (_jsxs(_Fragment, { children: [_jsx(ResponsiveIcon, { color: "action", Icon: Air, ...rest, ref: ref }), _jsx(ResponsiveIcon, { Icon: WbCloudyOutlined, ...rest, ref: ref })] }));
        case 'air-pid':
            return _jsx(ResponsiveIcon, { Icon: AirPid, ref: ref, ...rest });
        case 'air-pid-pza':
            return (_jsxs(_Fragment, { children: [_jsx(ResponsiveIcon, { Icon: AirPid, ref: ref, ...rest }), _jsx(ResponsiveIcon, { Icon: WbCloudyOutlined, ...rest, ref: ref })] }));
        default:
            return null;
    }
}));
IconElement.displayName = 'IconElement';
export function ConsumerControlIcon(props) {
    const { control_mode, ...rest } = props;
    const { mode } = control_mode;
    return _jsx(IconElement, { control_mode: mode, color: "action", ...rest });
}
